// Login
import InvalidateRecovery from "@views/login/InvalidateRecovery";
import Login from "@views/login/Login";
import Logout from "@views/login/Logout";
import RecoverPassword from "@views/login/RecoverPassword";
import SetPassword from "@views/login/SetPassword";

import store from "../../store";
import { discardAccountWhitelabel } from "@packages/util/whitelabel/whitelabelReset";

export default [
    {
        name: "Login",
        path: "/login",
        component: Login,
        meta: { requiresAuth: false },
        beforeEnter: () => {
            location.assign(`${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}/new/auth/login`); 
        }
    },
    {
        name: "Login",
        path: "/login/wcs",
        component: Login,
        meta: { requiresAuth: false },
        beforeEnter: () => {
            location.assign(`${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}/new/auth/login/wcs`); 
        }
    },
    {
        name: "Login",
        path: "/login/haggi",
        component: Login,
        meta: { requiresAuth: false },
        beforeEnter: () => {
            location.assign(`${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}/new/auth/login/haggi`); 
        }
    },
    {
        name: "Login",
        path: "/login/tely",
        component: Login,
        meta: { requiresAuth: false },
        beforeEnter: () => {
            location.assign(`${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}/new/auth/login/tely`); 
        }
    },
    {
        name: "Login",
        path: "/login/ntcorp",
        component: Login,
        meta: { requiresAuth: false },
        beforeEnter: () => {
            location.assign(`${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}/new/auth/login/ntcorp`); 
        }
    },
    {
        name: "Login",
        path: "/login/data-carrier",
        component: Login,
        meta: { requiresAuth: false },
        beforeEnter: () => {
            location.assign(`${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}/new/auth/login/data-carrier`); 
        }
    },
    {
        name: "Login",
        path: "/login/vivo",
        component: Login,
        meta: { requiresAuth: false },
        beforeEnter: () => {
            location.assign(`${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}/new/auth/login/vivo`); 
        }
    },
    {
        name: "Login",
        path: "/login/master",
        component: Login,
        meta: { requiresAuth: false },
        beforeEnter: () => {
            location.assign(`${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}/new/auth/login/master`); 
        }
    },

    {
        name: "Logout",
        path: "/logout",
        component: Logout,
        meta: { requiresAuth: false },
    },

    {
        name: "Logout",
        path: "/logout",
        component: Logout,
        meta: { requiresAuth: false },
    },

    {
        name: "RecoverPassword",
        path: "/recuperar-senha",
        component: RecoverPassword,
        meta: { requiresAuth: false },
    },

    {
        name: "SetPassword",
        path: "/definir-senha",
        component: SetPassword,
        meta: { requiresAuth: false },        
    },

    {
        name: "SetPassword",
        path: "/vivo/definir-senha",
        component: SetPassword,
        meta: { requiresAuth: false },
        beforeEnter: (_to, _from, next) => {
            localStorage.setItem('provider', 'vivo');
            store.commit('layout/LAYOUT_SET_PROVIDER', 'vivo');
            discardAccountWhitelabel();
            next();
        }
    },

    {
        name: "InvalidateRecovery",
        path: "/invalidar-recuperacao",
        component: InvalidateRecovery,
        meta: { requiresAuth: false },
    },
];
